export default "__VITE_ASSET__BXpwxxku__"